import { connect } from 'react-redux';

import { getIsMobile } from 'src/store/view/selectors';

import {
  addCouponAction,
  payByDiscountAction,
} from '../../../store/actions/order';
import {
  getOrderDiscountPrice,
  getRemainingPaymentAmount,
} from '../../../store/selectors/order';
import GiftCertificateInfo from './GiftCertificateInfo';

const mapStateToProps = (state) => ({
  priceWithDiscount: getRemainingPaymentAmount(state),
  discount: getOrderDiscountPrice(state) || 0,
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = (dispatch) => ({
  onCancel: () => dispatch(addCouponAction(null)),
  onSubmit: () => dispatch(payByDiscountAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiftCertificateInfo);
